/**
 * How wide a chat panel is, everywhere in the product.
 *
 * One number rather than three: the enterprise panel, the admin workflow builder and the affiliate
 * builder each carried their own (408, 480 and 400), so the same composer rendered three widths
 * and read as three different designs. 408 is the width the chat panel was designed at.
 */
export const PANEL_CHAT_WIDTH_PX = 408;
